<template>
    <div id="realtime-status">
        <v-ws :sendMessage="sendMessage" v-on:vehicle_search="changeSearchData" ></v-ws>
        <el-row :gutter="15">
            <el-col :span="10" >
                <v-search v-on:search="createVehicleSearch" v-on:select="searchSelectCurrent" :serchData="serchData"></v-search>
            </el-col>
            <el-col :span="14" >
                <div class="battery-info">
                    <!--el-row :gutter="10" class="info-summary">
                        <el-col :xs="24" :sm="12" :md="8" :lg="6">
                            <p class="summary-list"><span>当前电池编码：</span>11158 </p>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="6">
                            <p class="summary-list"><span>车牌号码：</span>粤B-000001 </p>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="6">
                            <p class="summary-list"><span>VIN码：</span>1G1JF27W8GJ178227</p>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="6">
                            <p class="summary-list"><span>电池单体总数：</span>5</p>
                        </el-col>
                    </el-row-->
                    <div class="info-summary">
                        <p class="summary-list"><span>当前电池编码：</span>11158 </p>
                        <p class="summary-list"><span>车牌号码：</span>粤B-000001 </p>
                        <p class="summary-list"><span>VIN码：</span>1G1JF27W8GJ178227</p>
                        <p class="summary-list"><span>电池单体总数：</span>5</p>
                        <p class="summary-list"><span>单体最高电压：</span>330V</p>
                        <p class="summary-list"><span>单体最高电压单体号：</span>100</p>
                        <p class="summary-list"><span>单体最低电压：</span>280V</p>
                        <p class="summary-list"><span>单体最低电压单体号：</span>100</p>
                        <p class="summary-list"><span>探针最高温度：</span>40℃</p>
                        <p class="summary-list"><span>探针最高温度探针号：</span>100</p>
                        <p class="summary-list"><span>单体最低电压单体号：</span>58</p>
                        <p class="summary-list"><span>探针最低温度：</span>35℃</p>
                        <p class="summary-list"><span>探针最低温度探针号：</span>78</p>
                    </div>
                    <el-tabs v-model="activeName" @tab-click="tabClick" class="">
                        <el-tab-pane label="用户管理" name="first">用户管理</el-tab-pane>
                        <el-tab-pane label="配置管理" name="second">配置管理</el-tab-pane>
                    </el-tabs>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import search from '../plugins/search';
import ws from '../plugins/ws';
export default {
    name: 'realtime-status',
    created () {
    },
    components: {
        'v-search': search,
        'v-ws': ws
    },
    data () {
        return {
            serchData: {},
            sendMessage: null,
            activeName: 'first'
        };
    },
    methods: {
        createVehicleSearch (value) {
            this.sendMessage = {
                topic: 'vehicle_search',
                action: 'create',
                data: value
            };
        },
        changeSearchData (data) {
            this.serchData = data;
        },
        searchSelectCurrent (car) {
            console.log(car);
        },
        tabClick () {

        }
    },
    computed: {
    }
};
</script>
<style scoped>
    #realtime-status {
    }
    .summary-list{
        margin:0;
        display: inline-block;
        min-width: 180px;
    }
    .battery-info{
        background-color: #fff;
        padding: 10px;
        height: 80vh;
        min-height: 680px;
        box-sizing: border-box;
    }
    .info-summary{
        padding: 50px  5px 5px 0px;
        text-align: left;
    }

</style>
<style>
    #realtime-status .el-tabs__header{
        position: absolute;
        top:0;
    }

</style>



// WEBPACK FOOTER //
// realtime-status.vue?7682a762